import { AfterViewInit, Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core'
import { LoadingService } from './services/common/loading.service'
import * as AOS from 'aos'
import { AuthService } from './services/common/auth.service'
import { Store } from '@ngrx/store'
import { AppState } from './store/state/app.state'
import { start_initializing } from './store/action/initialize.action'
import { initialInitializeState } from './store/state/initial.state'
import { Router } from '@angular/router'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { DynamicComponentLoaderService } from './services/component-loader/dynamic-component-loader.service'
import { GlobalConstants } from './constants/global-constants'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  @ViewChild('targetContainer', { read: ViewContainerRef }) targetContainer: ViewContainerRef
  targetComponentRef: ComponentRef<ResetPasswordComponent>
  loading$ = this.loader.loading$

  title = 'sop-portal'

  constructor(
    public loader: LoadingService,
    private authService: AuthService,
    private appState: Store<AppState>,
    private router: Router,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  ngOnInit(): void {
    AOS.init()
    if (this.authService.isUserAuthenticated()) {
      this.appState
        .select((state) => state.initialize)
        .subscribe((data) => {
          if (data === initialInitializeState) {
            this.appState.dispatch(start_initializing({ comingFromLogin: false }))
          }
        })
    }
  }

  isPanelEnabled() {
    const path = this.router.url.split('?')[0]

    return !(path === '/' || path === '/login' || path.startsWith('/login/'))
  }

  ngAfterViewInit(): void {
    this.dynamicComponentLoaderService.registerComponent(
      GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.key,
      this.targetContainer,
      GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.component
    )

    const newJoineeWorkflowNotificationPopup = GlobalConstants.DYNAMIC_MODEL.NEW_JOINEE_WORKFLOW_NOTIFICATION_POPUP
    this.dynamicComponentLoaderService.registerComponent(
      newJoineeWorkflowNotificationPopup.key,
      this.targetContainer,
      newJoineeWorkflowNotificationPopup.component
    )

    const pendingFromEmployeeQueryNotificationPopup =
      GlobalConstants.DYNAMIC_MODEL.PENDING_FROM_EMPLOYEE_NOTIFICATION_POPUP
    this.dynamicComponentLoaderService.registerComponent(
      pendingFromEmployeeQueryNotificationPopup.key,
      this.targetContainer,
      pendingFromEmployeeQueryNotificationPopup.component
    )
  }
}
